<script>
import { BFormGroup, BFormInput, } from 'bootstrap-vue'

export default {
    components: {BFormGroup, BFormInput},
    data() {
        return {
            substance: {
                name: '',
                ec: '',
                cas: '',
            },
        }
    },
    methods: {
        onInput() {
            this.$emit('input', this.substance);
        },
        clear() {
            this.substance.name = '';
            this.substance.ec = '';
            this.substance.cas = '';
        }
    }
}
</script>

<template>
    <div>
        <b-form-group
            :label="$t('Component(Label):name')"
            label-for="name"
        >
            <b-form-input
                id="name"
                v-model="substance.name"
                @input="onInput"
                :class="{'input-bg-warning': this.substance.name.length === 0}"
                :placeholder="$t('Component(Placeholder):name')"
            />
        </b-form-group>
        <b-form-group
            :label="$t('Component(SubstanceTable):column-ec')"
            label-for="ec"
        >
            <b-form-input
                id="ec"
                v-model="substance.ec"
                @input="onInput"
                :class="{'input-bg-warning': !this.substance.ec && !this.substance.cas}"
                :placeholder="$t('Component(SubstanceTable):column-ec')"
            />
        </b-form-group>
        <b-form-group
            :label="$t('Component(SubstanceTable):column-cas')"
            label-for="cas"
        >
            <b-form-input
                id="ec"
                v-model="substance.cas"
                @input="onInput"
                :class="{'input-bg-warning': !this.substance.ec && !this.substance.cas}"
                :placeholder="$t('Component(SubstanceTable):column-cas')"
            />
        </b-form-group>
    </div>
</template>
